<h1>Anslutningsfel!</h1>
<mat-dialog-content>
  <br />
  <h3>
    För att försöka igen klicka på <b>Försök igen</b> nedan.
  </h3>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button type="button" color="primary" mat-dialog-close>Försök igen</button>
</mat-dialog-actions>
